import React from "react";
import { MenuPerview, renderLogo } from "./NewHeaderRenderer";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";

const HeaderRendererDesktop = ({ headerConfig }) => {
  return (
    <div className="screen_header_outerbox ">
      <div className="desktop_nav_items " style={{ padding: "20px" }}>
        <div style={{ cursor: "move" }}>
          <div className="p_0">{renderLogo(headerConfig)}</div>
        </div>
        <div className="screen_header_options">
          <MenuPerview headerConfig={headerConfig} />
        </div>
        <div className="d_flex" style={{ position: "sticky" }}>
          <div className="screen_profile_icon screen">
            <MaterialIcon name="person" className="screen_header_user" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderRendererDesktop;
